module.exports = __webpack_public_path__ + "static/media/IPM-01.42210fc5.jpg";